import ContactHome from "@/app/contact/home.page";
import ContactPropertyPage from "@/app/contact/property.page";
import ContactAppointmentsPage from "@/app/contact/appointments.page";
import ContactAppointmentPage from "@/app/contact/appointment.page";

export const contact_routes = [
  {
    path: "/",
    element: <ContactHome />,
  },
  {
    path: "/properties/:propertyId",
    element: <ContactPropertyPage />,
  },
  {
    path: "/appointments",
    element: <ContactAppointmentsPage />,
  },
  {
    path: "/appointments/:appointmentId",
    element: <ContactAppointmentPage />,
  },
];
